import React from 'react';

// --------------------------------------
// TODO GERER LES PREFIXES DEPUIS LE CONTEXTE OU AUTRE COMPOSANT COMMUN

export function Row(props) {
	return (
		<div className='row' {...props}>
			{props.children}
		</div>
	);
}
